<template>
  <div class="search">
    <v-card class="mb-6" v-if="result">
      <v-list class="pa-0" two-line>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-library</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ name }}</v-list-item-title>
            <v-list-item-subtitle class="pt-1"
              >Library / ห้องสมุด</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider />
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-shape</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $route.params.category }}</v-list-item-title>
            <v-list-item-subtitle class="pt-1"
              >Category / ประเภทหนังสือ</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider />
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-layers-triple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ result.end.floor }}</v-list-item-title>
            <v-list-item-subtitle class="pt-1"
              >Floor / ชั้น</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider />
        <v-list-item v-if="!result.end.id.startsWith('SP')">
          <v-list-item-icon>
            <v-icon>mdi-library-shelves</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              result.end.id.substring(2)
            }}</v-list-item-title>
            <v-list-item-subtitle class="pt-1"
              >Shelf / เลขตู้</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider v-if="!result.end.id.startsWith('SP')" />
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-pound-box</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $route.params.code }}</v-list-item-title>
            <v-list-item-subtitle class="pt-1"
              >Call Number / เลขเรียกหนังสือ</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider v-if="$route.params.barcode" />
        <v-list-item v-if="$route.params.barcode">
          <v-list-item-icon>
            <v-icon>mdi-barcode</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $route.params.barcode }}</v-list-item-title>
            <v-list-item-subtitle class="pt-1"
              >Barcode / บาร์โค้ด</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
    <v-card class="mb-6" v-if="result">
      <v-tabs background-color="primary" dark grow v-model="tab">
        <v-tab>Location<br />ตำแหน่งหนังสือ</v-tab>
        <v-tab>Directions<br />ดูเส้นทาง</v-tab>
      </v-tabs>
    </v-card>
    <v-tabs-items touchless v-if="result" v-model="tab">
      <v-tab-item>
        <v-stage
          :config="{
            height: images[result.end.floor].naturalHeight,
            width: images[result.end.floor].naturalWidth
          }"
          class="map mb-6"
          v-if="images[result.end.floor]"
        >
          <v-layer>
            <v-image
              :config="{
                image: images[result.end.floor],
                preventDefault: false
              }"
            />
            <v-line
              :config="{
                points: [
                  result.end.x,
                  result.end.y,
                  result.end.x,
                  result.end.y - 50
                ],
                ...redLine
              }"
              v-if="!result.end.id.startsWith('SP')"
            />
            <v-circle
              :config="{
                x: result.end.x,
                y: result.end.y - 100,
                ...redCircle
              }"
              v-if="!result.end.id.startsWith('SP')"
            />
            <v-text
              :config="{
                text: 'Shelf',
                x: result.end.x - 50,
                y: result.end.y - 170,
                ...whiteTextSmall
              }"
              v-if="!result.end.id.startsWith('SP')"
            />
            <v-text
              :config="{
                text: result.end.id.substring(2),
                x: result.end.x - 50,
                y: result.end.y - 130,
                ...whiteTextLarge
              }"
              v-if="!result.end.id.startsWith('SP')"
            />
            <v-image
              :config="{
                image: marker,
                preventDefault: false,
                x: result.end.x - 64,
                y: result.end.y - 128
              }"
              v-if="result.end.id.startsWith('SP')"
            />
          </v-layer>
        </v-stage>
      </v-tab-item>
      <v-tab-item>
        <v-select
          :items="checkpoints"
          class="d-flex d-sm-none mb-6"
          clearable
          hide-details
          label="Your location / ตำแหน่งที่คุณอยู่"
          outlined
          placeholder="Please select your location / เลือกตำแหน่งที่คุณอยู่"
          prepend-inner-icon="mdi-map-marker"
          v-model="checkpoint"
        />
        <v-autocomplete
          :items="checkpoints"
          autocomplete="off"
          class="d-none d-sm-flex mb-6"
          clearable
          hide-details
          label="Your location / ตำแหน่งที่คุณอยู่"
          outlined
          placeholder="Please select your location / เลือกตำแหน่งที่คุณอยู่"
          prepend-inner-icon="mdi-map-marker"
          v-model="checkpoint"
        />
        <div
          :class="
            parseInt(result.start.floor.replace(/[^\d]/g, '')) >
            parseInt(result.end.floor.replace(/[^\d]/g, ''))
              ? 'reversed'
              : ''
          "
          v-if="checkpoint"
        >
          <template v-for="(path, i) in result.paths">
            <v-stage
              :config="{
                height: images[i].naturalHeight,
                width: images[i].naturalWidth
              }"
              :key="i"
              class="map mb-6"
              v-if="images[i] && path.length"
            >
              <v-layer>
                <v-image
                  :config="{ image: images[i], preventDefault: false }"
                />
                <v-arrow
                  :config="{ points: path, ...blueLine }"
                  v-if="path.length"
                />
                <v-circle
                  :config="{
                    x: result.start.x,
                    y: result.start.y,
                    ...whiteCircle
                  }"
                  v-if="i == result.start.floor"
                />
                <v-text
                  :config="{
                    text: checkpoint,
                    x: result.start.x - 50,
                    y: result.start.y - 50,
                    ...blackText
                  }"
                  v-if="i == result.start.floor"
                />
                <v-line
                  :config="{
                    points: [
                      result.end.x,
                      result.end.y,
                      result.end.x,
                      result.end.y - 50
                    ],
                    ...redLine
                  }"
                  v-if="
                    !result.end.id.startsWith('SP') && i == result.end.floor
                  "
                />
                <v-circle
                  :config="{
                    x: result.end.x,
                    y: result.end.y - 100,
                    ...redCircle
                  }"
                  v-if="
                    !result.end.id.startsWith('SP') && i == result.end.floor
                  "
                />
                <v-text
                  :config="{
                    text: 'Shelf',
                    x: result.end.x - 50,
                    y: result.end.y - 170,
                    ...whiteTextSmall
                  }"
                  v-if="
                    !result.end.id.startsWith('SP') && i == result.end.floor
                  "
                />
                <v-text
                  :config="{
                    text: result.end.id.substring(2),
                    x: result.end.x - 50,
                    y: result.end.y - 130,
                    ...whiteTextLarge
                  }"
                  v-if="
                    !result.end.id.startsWith('SP') && i == result.end.floor
                  "
                />
                <v-image
                  :config="{
                    image: marker,
                    preventDefault: false,
                    x: result.end.x - 64,
                    y: result.end.y - 128
                  }"
                  v-if="result.end.id.startsWith('SP') && i == result.end.floor"
                />
              </v-layer>
            </v-stage>
          </template>
        </div>
      </v-tab-item>
    </v-tabs-items>
    <v-btn block large to="/">Back / กลับ</v-btn>
  </div>
</template>

<script>
import graphlib from "graphlib";
export default {
  computed: {
    result() {
      const parts = this.$route.params.code
        .replace(/([.][A-Zก-๛])/g, " $1")
        .replace(/[ ]+/g, " ")
        .split(" ")
        .map(i => i.replace(/^[.]+/, ""))
        .concat(["", ""]);
      const keys = Object.keys(this.codes);
      let code;
      for (let i = 0; i < keys.length; i++) {
        if (
          (keys[i].substring(0, 2) != "TH" ||
            (keys[i].substring(0, 2) == "TH" &&
              /[ก-๛]/.test(this.$route.params.code)) ||
            this.patterns["TH"][1].test(parts[1])) &&
          this.$route.params.category === this.codes[keys[i]].category &&
          this.patterns[keys[i].substring(0, 2)][0].test(parts[0]) &&
          this.patterns[keys[i].substring(0, 2)][1].test(parts[1]) &&
          this.patterns[keys[i].substring(0, 2)][2].test(parts[2])
        ) {
          const c1 = parts[0].replace(/[0-9.ก-๛]/g, "");
          const c2 = parts[1].replace(/[0-9.]/g, "");
          const c3 = this.codes[keys[i]].first.replace(/[0-9.]/g, "");
          const c4 = this.codes[keys[i]].second.replace(/[0-9.]/g, "");
          const n1 = parseFloat(parts[0].replace(/[^0-9.]/g, "")) || 0;
          const n2 = parseFloat(parts[1].replace(/[^0-9.]/g, "")) || 0;
          const n3 =
            parseFloat(this.codes[keys[i]].first.replace(/[^0-9.]/g, "")) || 0;
          const n4 =
            parseFloat(this.codes[keys[i]].second.replace(/[^0-9.]/g, "")) || 0;
          if (
            c1 < c3 ||
            (c1 === c3 && n1 < n3) ||
            (c1 === c3 && n1 === n3 && c2 < c4) ||
            (c1 === c3 && n1 === n3 && c2 === c4 && n2 < n4)
          ) {
            break;
          } else {
            code = keys[i];
          }
        }
      }
      if (!code) return null;
      if (!this.checkpoint) return { end: { ...this.nodes[code], id: code } };
      const graph = new graphlib.Graph();
      Object.keys(this.nodes).forEach(i => {
        graph.setNode(i);
        this.nodes[i].from.forEach(j => graph.setEdge(j, i));
      });
      const dijkstra = graphlib.alg.dijkstra(graph, "CP" + this.checkpoint, e =>
        Math.hypot(
          this.nodes[e.w].x - this.nodes[e.v].x,
          this.nodes[e.w].y - this.nodes[e.v].y
        )
      );
      const paths = {};
      this.floors.forEach(i => (paths[i] = []));
      let current = code;
      while (current !== "CP" + this.checkpoint) {
        paths[this.nodes[current].floor].unshift(this.nodes[current].y);
        paths[this.nodes[current].floor].unshift(this.nodes[current].x);
        current = dijkstra[current].predecessor;
      }
      paths[this.nodes[current].floor].unshift(this.nodes[current].y);
      paths[this.nodes[current].floor].unshift(this.nodes[current].x);
      return {
        end: { ...this.nodes[code], id: code },
        paths: paths,
        start: this.nodes["CP" + this.checkpoint]
      };
    }
  },
  data() {
    return {
      checkpoint: null,
      images: {},
      tab: 0,
      blackText: {
        align: "center",
        fill: "black",
        fontSize: 25,
        height: 100,
        preventDefault: false,
        stroke: "black",
        strokeWidth: 1,
        verticalAlign: "middle",
        width: 100
      },
      blueLine: {
        dash: [15, 15],
        pointerLength: 15,
        pointerWidth: 15,
        preventDefault: false,
        shadowBlur: 5,
        stroke: "#4A89F3",
        strokeWidth: 10
      },
      marker: null,
      redLine: {
        lineCap: "round",
        lineJoin: "round",
        preventDefault: false,
        shadowBlur: 5,
        stroke: "#DD4B3E",
        strokeWidth: 10
      },
      redCircle: {
        fill: "#DD4B3E",
        preventDefault: false,
        radius: 50,
        shadowBlur: 5
      },
      whiteCircle: {
        fill: "#FFFFFF",
        preventDefault: false,
        radius: 20,
        shadowBlur: 5
      },
      whiteTextLarge: {
        align: "center",
        fill: "white",
        fontSize: 50,
        height: 100,
        preventDefault: false,
        shadowBlur: 5,
        stroke: "white",
        strokeWidth: 2,
        verticalAlign: "middle",
        width: 100
      },
      whiteTextSmall: {
        align: "center",
        fill: "white",
        fontSize: 25,
        height: 100,
        preventDefault: false,
        shadowBlur: 5,
        stroke: "white",
        strokeWidth: 1,
        verticalAlign: "middle",
        width: 100
      }
    };
  },
  created() {
    this.$gtag.event("search", {
      library: this.name,
      category: this.$route.params.category,
      code: this.$route.params.code,
      barcode: this.$route.params.barcode
    });
  },
  mounted() {
    this.floors.forEach(i => {
      const image = new window.Image();
      image.src = "/" + this.slug + "-" + i + ".png";
      image.onload = () => this.$set(this.images, i, image);
    });
    const image = new window.Image();
    image.src = "/marker.png";
    image.onload = () => (this.marker = image);
  },
  props: [
    "categories",
    "checkpoints",
    "codes",
    "floors",
    "name",
    "nodes",
    "patterns",
    "slug"
  ]
};
</script>

<style>
.reversed {
  display: flex;
  flex-direction: column-reverse;
}
</style>
